module.exports = __webpack_public_path__ + "img/banner2.1b1a4b8a.png";